
import { Component, Vue, Prop } from 'vue-property-decorator';

import DialogCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import OrderAddressCustom from '../order/components/OrderAddressCustom.vue';
import DialogArea from '../order/components/OrderArea.vue';
import dialogAddCustomer from '../customer/components/CustomerAddDialog.vue';
import DialogDevice from '@/components/DeviceSelectDialog/index.vue';
import dialogAddDevice from '../device/components/DeviceDialog.vue';
import DialogSelectUserPolling from './components/selectUserPolling.vue';
import DialogSelectEvent from './components/selectEvent.vue';
import DialogAddEvent from './components/selectEventAdd.vue';
import { UserModule } from '@/store/modules/user';
import { addPlan } from '@/api/orderPolling';
import { addOrderServerIsHave, addOrderServerIsMust } from '@/utils/permission';
import { OrderType, Type } from '@/types/permissionType';
import { AnyAaaaRecord } from 'dns';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import { getDepartmentList } from '@/api/company';
import { getFaultList, getPriceList } from '@/api/other';

@Component({
  name: 'OrderPollingAdd',
  components: {
    DialogCustomer,
    DialogArea,
    OrderAddressCustom,
    dialogAddCustomer,
    DialogDevice,
    dialogAddDevice,
    DialogSelectUserPolling,
    DialogSelectEvent,
    DialogAddEvent,
    DialogLveReportDept
  }
})
export default class extends Vue {
  private isMulti:any=0;
  private multiType:any=0;
  private selectDevice:any=[];
  private formCont:any = {
    customer: '',
    area: '',
    address: '',
    name: '',
    mobile: '',
    telephone: '',
    userDept: [],
    device: [],
    event: '',
    topEvent: '',

    planName: '',
    service: '',
    deptengineer: '',
    deptengineerObj: {},

    startTime: '',
    endTime: '',
    day: '',
    repetition: '',
    repeatTimes: 1,
    checkboxWeek: [],
    repetitionMonthEveryday: [],
    repetitionMonthType: 'day',
    repetitionMonthWW: '',
    repetitionMonthWhich: '',
    repetitionYearWeek: '',
    repetitionYearWW: '',
    repetitionYearWhich: '',
    repetitionYearEveryMonth: [],

    timelist: [{
      hours: { value: 0,
        label: '00' },
      minutes: { value: 0,
        label: '00' }

    }],
    ahead: ''
  }
  private isShowCus=parseInt(((UserModule.getCompany as any).vip_level).substring(0, 1)) === 3;
  private companyId=UserModule.getCompanyId;
  private customerVisible = false
  private areaVisible = false
  private dialogAddCustomerVisible = false

  private deviceVisible = false
  private dialogAddDeviceVisible = false

  private dialogSelectEventVisible = false
  private dialogAddEventVisible = false
  private formSearchAddEvent = {
    name: ''
  }
  private dayOptions = [{
    value: '0',
    label: '任务当天'
  }, {
    value: '1',
    label: '1天'
  }, {
    value: '2',
    label: '2天'
  }, {
    value: '3',
    label: '3天'
  }, {
    value: '4',
    label: '4天'
  }, {
    value: '5',
    label: '5天'
  }, {
    value: '6',
    label: '6天'
  }, {
    value: '7',
    label: '7天'
  }]
  private weekOptions = [{
    value: '7',
    name: '星期日'
  }, {
    value: '1',
    name: '星期一'
  }, {
    value: '2',
    name: '星期二'
  }, {
    value: '3',
    name: '星期三'
  }, {
    value: '4',
    name: '星期四'
  }, {
    value: '5',
    name: '星期五'
  }, {
    value: '6',
    name: '星期六'
  }]
  private repetitionMonthEveyday:any = []
  private repetitionYearTable = [{
    row: [{
      value: 1,
      name: '一月'
    }, {
      value: 2,
      name: '二月'
    }, {
      value: 3,
      name: '三月'
    }, {
      value: 4,
      name: '四月'
    }]
  }, {
    row: [{
      value: 5,
      name: '五月'
    }, {
      value: 6,
      name: '六月'
    }, {
      value: 7,
      name: '七月'
    }, {
      value: 8,
      name: '八月'
    }]
  }, {
    row: [{
      value: 9,
      name: '九月'
    }, {
      value: 10,
      name: '十月'
    }, {
      value: 11,
      name: '十一月'
    }, {
      value: 12,
      name: '十二月'
    }]
  }]

  private repetitionMonthWWOptions = [{
    value: '1',
    label: '第一个'
  }, {
    value: '2',
    label: '第二个'
  }, {
    value: '3',
    label: '第三个'
  }, {
    value: '4',
    label: '第四个'
  }, {
    value: '5',
    label: '第五个'
  }, {
    value: '6',
    label: '最后一个'
  }]
  private repetitionMonthWhichOptions = [{
    value: '7',
    label: '星期日'
  }, {
    value: '1',
    label: '星期一'
  }, {
    value: '2',
    label: '星期二'
  }, {
    value: '3',
    label: '星期三'
  }, {
    value: '4',
    label: '星期四'
  }, {
    value: '5',
    label: '星期五'
  }, {
    value: '6',
    label: '星期六'
  }, {
    value: '8',
    label: '自然日'
  }, {
    value: '9',
    label: '工作日'
  }, {
    value: '10',
    label: '周末'
  } ]
  private repetitionOptions = [{
    value: '5',
    label: '一次'
  }, {
    value: '4',
    label: '按天'
  }, {
    value: '3',
    label: '按周'
  }, {
    value: '2',
    label: '按月'
  }, {
    value: '1',
    label: '按年'
  }]
  private hoursOptions:any = []
  private minutesOptions:any = []
  private aheadOptions:any = []

  private isHaveUserDept=parseInt(UserModule.getCompanyId) !== 0
  private isShowCusDept=false;
  private isMustCusDept=false;

  private isShowAddress=true;
  private isShowContentUser=true;
  private isShowContentUserMobile=true;
  private isShowContentUserPhone=true;

  private isMustAddress=false;
  private isMustContentUser=false;
  private isMustContentUserMobile=false;
  private isMustContentUserPhone=false;

  private isShowAddressPca=false;
  private isMustAddressPca=false;
  private isShowAddressSelf=false;
  private isMustAddressSelf=false;

  private isShowDevice=false
  private isMustDevice=false


  private isShowPrice=false;
  private isMustPrice=false;
  //添加费用是否可修改
  private isModifyOtherPrice = parseInt((UserModule.getCompany as any).is_modify_other_price) === 1;;
  private dynamicCost:any = [];
  private costList:any = [];

  private servicerChange(orderType:any) {
    this.isShowDevice = addOrderServerIsHave(Type.device, orderType, '');
    this.isMustDevice = addOrderServerIsMust(Type.device, orderType, '');

    this.isShowCusDept = addOrderServerIsHave(Type.CUS_DEPT, orderType, '');
    this.isMustCusDept = addOrderServerIsMust(Type.CUS_DEPT, orderType, '');

    this.isShowPrice = addOrderServerIsHave(Type.price, orderType, '');
    this.isMustPrice = addOrderServerIsMust(Type.price, orderType, '');

    this.isShowAddressPca = addOrderServerIsHave(Type.pca, orderType, '');
    this.isShowAddressSelf = addOrderServerIsHave(Type.myselfPCALs, orderType, '');

    this.isShowAddress = addOrderServerIsHave(Type.address, orderType, '');

    this.isShowContentUser = addOrderServerIsHave(Type.contentUser, orderType, '');
    this.isShowContentUserMobile = addOrderServerIsHave(Type.contentUserMobile, orderType, '');
    this.isShowContentUserPhone = addOrderServerIsHave(Type.contentUserPhone, orderType, '');

    this.isMustAddressPca = addOrderServerIsMust(Type.pca, orderType, '');
    this.isMustAddressSelf = addOrderServerIsMust(Type.myselfPCALs, orderType, '');

    this.isMustContentUser = addOrderServerIsMust(Type.contentUser, orderType, '');
    this.isMustContentUserMobile = addOrderServerIsMust(Type.contentUserMobile, orderType, '');
    this.isMustContentUserPhone = addOrderServerIsMust(Type.contentUserPhone, orderType, '');
    this.isMustAddress = addOrderServerIsMust(Type.address, orderType, '');
  }

  created() {
    this.servicerChange(OrderType.CheckModule);
    this.init()
  }
  private init() {
    for (let index = 0; index < 23; index++) {
      let obj:any = {
        value: index,
        label: index >= 10 ? index : ('0' + index)
      };
      this.hoursOptions.push(obj);
    }
    for (let index = 1; index < 10; index++) {
      let obj:any = {
        value: index,
        label: index === 1 ? '任务开始时' : index === 2 ? '半小时前' : (index - 1) + '小时前'
      };
      this.aheadOptions.push(obj);
    }
    for (let index = 0; index < 12; index++) {
      const minutes = index * 5 >= 10 ? index * 5 : ('0' + index * 5) ;
      let obj:any = {
        value: minutes,
        label: minutes
      };
      this.minutesOptions.push(obj);
    }
    let arr:any = [];
    let arr1:any = [];
    let arr2:any = [];
    let arr3:any = [];
    let arr4:any = [];
    for (let index = 1; index < 32; index++) {
      let obj:any = {
        value: index,
        name: index
      };
      if (index < 8) {
        arr.push(obj);
        if (index === 7) {
          let row:any = {};
          row.row = arr;
          this.repetitionMonthEveyday.push(row);
        }
      } else if (index < 15) {
        arr1.push(obj);
        if (index === 14) {
          let row:any = {};
          row.row = arr1;
          this.repetitionMonthEveyday.push(row);
        }
      } else if (index < 22) {
        arr2.push(obj);
        if (index === 21) {
          let row:any = {};
          row.row = arr2;
          this.repetitionMonthEveyday.push(row);
        }
      } else if (index < 29) {
        arr3.push(obj);
        if (index === 28) {
          let row:any = {};
          row.row = arr3;
          this.repetitionMonthEveyday.push(row);
        }
      } else {
        arr4.push(obj);
        if (index === 31) {
          let row:any = {};
          row.row = arr4;
          this.repetitionMonthEveyday.push(row);
        }
      }
    }
  }
  private handleTabClick(tab:any) {
    if(this.isMulti==1){
      if(this.isShowCusDept){
        this.multiType ='1';
      }else if(this.isShowDevice){
        this.multiType ='2';
      }
    }else{
      this.multiType ='0';
    }
    this.formCont.device = [];
 
  }
  private handleMultiType(){
     if(this.multiType == '1'){
      // if(this.formCont.device && this.formCont.device.length>1){
        this.formCont.device = [];
      // }
     }else{
      // if(this.formCont.userDept && this.formCont.userDept.length>1){
        this.formCont.userDept = [];
      // }
     }
  }
  private addCustomerButton() {
    this.dialogAddCustomerVisible = true;
  }
  private closeAddCustomer(val: boolean) {
    this.dialogAddCustomerVisible = val;
  }
  private addCustomerHandle(val:any) {
    this.dialogAddCustomerVisible = false;
  }

  // 设备选择
  private selectDeviceHandle() {
    if(this.isShowCus){
      //检查是否选择了客户
      if(!this.formCont.customer|| !this.formCont.customer.id){
        this.showErrorMsg('请选择客户');
        return;
      }
    }
    this.deviceVisible = true;
  }
  private closeDeviceHandle(val: boolean) {
    this.deviceVisible = val;
  }
  private confirmDeviceHandle(values:any) {
    if(parseInt(this.multiType)===2){
          // this.formCont.device = [];
      values.forEach( (value:any) => {
        this.formCont.device.push(value);
        if (value.device_address) {
          this.formCont.address = value.device_address
        }
      });
    }else{
      this.formCont.device = [values];
    }
    //从设备中获取部门
    this.setCusDeptFromDevice();
  }
  // 添加设备
  private addDeviceButton() {
    this.dialogAddDeviceVisible = true;
  }
  private deviceDialogOperat() {

  }
  private closeDevice(val: boolean) {
    this.dialogAddDeviceVisible = val;
  }
  private delDevice(index:any) {
    this.formCont.device.splice(index, 1);
  }
  private delDeviceChild(index:any, childIndex:any) {
    this.formCont.device[index].child.splice(childIndex, 1);
  }
  private selectEventHandle() {
    this.dialogSelectEventVisible = true;
  }
  private isLower: number = 0
  //选择巡检事件
  private dialogSelectEvent(val: any) {
    if (val.lower) {
      this.isLower = 1;
      this.formCont.topEvent = val;
      this.formCont.event = val.lower;
      for (let i = 0; i < this.formCont.event.length; i++) {
        this.$set(this.formCont.event[i], 'isShowEvent', false);
      }
    } else if (val.child) {
      this.isLower = 2;
      this.formCont.topEvent = val;
      this.formCont.event = val;
      this.$set(this.formCont.event, 'isShowEvent', false);
    } else {
      this.isLower = 0;
      this.formCont.topEvent = '';
      this.formCont.event = '';
    }
  }
  private closeSelectEvent(val: any) {
    this.dialogSelectEventVisible = val;
  }

  // 自定义事件显示
  private delEvent(index:any, isLower: number) {
    if (!isLower) {
      return;
    }
    if (isLower === 2) {
      this.formCont.event = '';
    } else {
      this.formCont.event.splice(index, 1);
    }
    if(this.formCont.event.length<1){
      this.formCont.topEvent = '';
    }
  }
  private delEventChild(index:any, childIndex:any, isLower: number) {
    if (!isLower) {
      return;
    }
    if (isLower === 1) {
      this.formCont.event[index].child.splice(childIndex, 1);
    }
    if (isLower === 2) {
      this.formCont.event.child.splice(childIndex, 1);
    }
    if(this.formCont.event.length<1){
      this.formCont.topEvent = '';
    }
  }
  private addEventButton() {
    this.dialogAddEventVisible = true;
  }
  private dialogSelectEventAdd(val: any) {
    this.isLower = 2;
    this.formCont.event = val;
    this.$set(this.formCont.event, 'isShowEvent', false);
  }
  private closeAddEvent(val: any) {
    this.dialogAddEventVisible = val;
  }
  private isShowEvent= false
  private eventToggle(val:any) {
    val.isShowEvent = !val.isShowEvent;
  }
  private eventEdit(val: any) {
    // 设置设备检查项弹框
  }
  // 客户
  private selectCustomerHandle() {
    this.customerVisible = true;
  }
  private customerConfirm(val:any) {
    this.formCont.customer = val;
    if (val.province_name) {
      this.formCont.area = val.province_name + '  ' + val.city_name + '  ' + val.district_name;
      this.formCont.province_name = val.province_name;
      this.formCont.province = val.province;
      this.formCont.city_name = val.city_name;
      this.formCont.city = val.city;
      this.formCont.district_name = val.district_name;
      this.formCont.district = val.district;
    }
    if (val.address) {
      this.formCont.address = val.address;
    }
    this.formCont.name = val.manager;
    this.formCont.mobile = val.mobile;
    this.formCont.telephone = val.phone_num;
  }
  private closeCustomerHandle(val: any) {
    this.customerVisible = val;
  }

   
  // 报修部门
  private departmentLevVisible=false
  private selectReportDept() {
    this.departmentLevVisible = true;
  }
  private selectDeptLev(value:any) {
    //
    this.formCont.userDept = [value];
    //设置部门
    
  }
  private handleLveReportDeptConfirm() {
    this.departmentLevVisible = false;
    // this.formCont.userDeptName = this.formCont.userDept.name;
  }
  private handleDeptChange(val:any) {
    this.formCont.userDept = val;
  }
  private setCusDeptFromDevice(){
    //从设备中获取部门
    if(!this.isShowCusDept){
      return;
    }
    if (this.formCont.device && this.formCont.device.length > 0) {
      //最后一个
      const deviceLast =  this.formCont.device[this.formCont.device.length-1];
      if(deviceLast.dept_id>0){
        this.formCont.userDept = [{name:deviceLast.dept_name,dept_id:deviceLast.dept_id}];
      }
    }
  }
  private closeDialogLveReportDept() {
    this.formCont.userDept = [];
    this.departmentLevVisible = false;
  }
  private handleDelUserDept(index:any) {
    this.formCont.userDept.splice(index, 1);
  }
  // 获取报修部门
  private getReportDept(type:any) {
    let params: any = {
      user_id:UserModule.getUserId ? UserModule.getUserId : '0',
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      type: type, // type=9 查所有部门  type=2查服务部门
      size: 1000,
      page: 1,
      source_type: 1
    };
    getDepartmentList(params)
      .then((res) => {

        if (res.data) {
          if (!res.data.list || res.data.list.length < 1) {
            this.isHaveUserDept = false;
          } else if (res.data.list.length === 1) {
            this.isHaveUserDept = true;
            // this.formCont.userDeptName = res.data.list[0].name;
            this.formCont.userDept = [res.data.list[0]];
          } else {
            this.isHaveUserDept = true;
          }
        }else{
          this.isHaveUserDept = false;
        }
    
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  // 添加费用
  private addCostHandle() {
    this.dynamicCost.push({
      type: '',
      value: ''
    });
  }
  private removeCostHandle(v:any) {
    let index = this.dynamicCost.indexOf(v);
    if (index !== -1) {
      this.dynamicCost.splice(index, 1);
    }
  }

  // 费用
  private getPriceList() {
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId;
    getPriceList(parameters).then(res => {
      if (res.data) {
        this.costList = res.data.list;
      } else {
        this.costList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private priceChange(price:any) {
    this.$set(this.formCont, 'costValue', price.price_num);
  }
  private priceNewChange(index:number, price:any) {
    this.$set(this.dynamicCost[index], 'value', price.price_num);
  }

  // 省市区
  private selectAreaHandle() {
    if (this.isShowAddressPca) {
      this.areaVisible = true;
    } else if (this.isShowAddressSelf) {
      this.areaCustomVisible = true;
    }
  }
  private saveAreaHandle(value:any) {
    if (value.province_name) {
      this.formCont.area = value.province_name + '  ' + value.city_name + '  ' + value.district_name;
    }
    this.formCont.province_name = value.province_name;
    this.formCont.province = value.province;
    this.formCont.city_name = value.city_name;
    this.formCont.city = value.city;
    this.formCont.district_name = value.district_name;
    this.formCont.district = value.district;
    this.areaVisible = false;
  }
  private closeAreaHandle(val: any) {
    this.areaVisible = val;
  }
  // 选择自定义
  private areaCustomVisible = false
  private oneAddress=''
  private oneAddressId=''
  private twoAddress=''
  private twoAddressId=''
  private threeAddress=''
  private threeAddressId=''
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = JSON.parse(value.pBean1).address;
        this.twoAddressId = JSON.parse(value.pBean1).id;
        this.threeAddress = value.address;
        this.threeAddressId = value.id;
      } else if (value.pBean) {
        this.oneAddress = JSON.parse(value.pBean).address;
        this.oneAddressId = JSON.parse(value.pBean).id;
        this.twoAddress = value.address;
        this.twoAddressId = value.id;
        this.threeAddress = '';
        this.threeAddressId = '0';
      } else {
        this.oneAddress = value.address;
        this.oneAddressId = value.id;
        this.twoAddress = '';
        this.twoAddressId = '0';
        this.threeAddress = '';
        this.threeAddressId = '0';
      }
    }
    this.formCont.area = this.oneAddress + '  ' + this.twoAddress + '  ' + this.threeAddress;
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  private addTimeButton() {
    this.formCont.timelist.push({
      hours: { value: 0,
        label: '00' },
      minutes: { value: 0,
        label: '00' }

    });
  }
  private deleteTimeButton(index: any) {
    this.formCont.timelist.splice(index, 1);
  }

  private dialogSelectPolling = false
  private pollingType = 1

  selectServiceHandle() {
    this.pollingType = 1;
    this.dialogSelectPolling = true;
  }
  selectEngineerHandle() {
    this.pollingType = 2;
    this.dialogSelectPolling = true;
  }
  private serviceChecked(val:any) {
    this.formCont.service = val;
    this.dialogSelectPolling = false;
  }
  private engineerChecked(val:any) {
    this.formCont.deptengineerObj = val;
  }
  private delEngTagHandle(index:number) {
    if (index === -1) {
      this.formCont.deptengineerObj.servicer_dept_name = '';
      this.formCont.deptengineerObj.servicer_dept_id = '';
    } else {
      this.formCont.deptengineerObj.engList.splice(index, 1);
    }
  }
  closeSelectPolling(val:boolean) {
    this.dialogSelectPolling = val;
  }
  // 重复
  private repetitionSelectChange(val:any) {
    this.formCont.repeatTimes = 1;
  }
  private selectRepetition(val: any) {

    // console.log(this.formCont.repetitionMonthEveryday);
    const index = this.formCont.repetitionMonthEveryday.findIndex( (v:any)=>{return v.value==val.value });
    if(index!=-1){
      //移除
      this.formCont.repetitionMonthEveryday.splice(index, 1);
    }else{
      //push 
      this.formCont.repetitionMonthEveryday.push(val);// push之后需要去重
    }
    // console.log(this.formCont.repetitionMonthEveryday);

    // this.formCont.repetitionMonthEveryday.push(val);// push之后需要去重
    // let obj:any = {};
    // this.formCont.repetitionMonthEveryday =
    // this.formCont.repetitionMonthEveryday.reduce(function(preValue: any, curValue:any) {
    //   // eslint-disable-next-line no-unused-expressions
    //   obj[curValue.value] ? '' : obj[curValue.value] = true && preValue.push(curValue);
    //   return preValue;
    // }, []);

    for (let i = 0; i < this.repetitionMonthEveyday.length; i++) {
      let ele: any = this.repetitionMonthEveyday[i].row;
      for (let t = 0; t < ele.length; t++) {
        if (ele[t].value === val.value) {
          this.$set(ele[t], 'isActive', !ele[t].isActive);
        }
      }
    }
  }
  private selectRepetitionYear(val: any) {

    //如果数组已有删除 没有新增 ]
    // console.log(this.formCont.repetitionYearEveryMonth);
    const index = this.formCont.repetitionYearEveryMonth.findIndex( (v:any)=>{return v.value==val.value });
    if(index!=-1){
      //移除
      this.formCont.repetitionYearEveryMonth.splice(index, 1);
    }else{
      //push 
      this.formCont.repetitionYearEveryMonth.push(val);// push之后需要去重
    }
    // console.log(this.formCont.repetitionYearEveryMonth);

    // let obj:any = {};
    // console.log(this.formCont.repetitionYearEveryMonth);
    // this.formCont.repetitionYearEveryMonth =
    // this.formCont.repetitionYearEveryMonth.reduce(function(preValue: any, curValue:any) {
    //   // eslint-disable-next-line no-unused-expressions
    //   obj[curValue.value] ? '' : obj[curValue.value] = true && preValue.push(curValue);
    //   return preValue;
    // }, []);
    // console.log(this.formCont.repetitionYearEveryMonth);
    for (let i = 0; i < this.repetitionYearTable.length; i++) {
      let ele: any = this.repetitionYearTable[i].row;
      for (let t = 0; t < ele.length; t++) {
        if (ele[t].value === val.value) {
          this.$set(ele[t], 'isActive', !ele[t].isActive);
        }
      }
    }
  }

  private saveHandle() {
    this.pamarsCheck('0');
  }
  private createHandle() {
    this.pamarsCheck('1');
  }
  private loading=false;
  private pamarsCheck(immediately:any) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_name = UserModule.getCompanyName;
    // if (!this.formCont.planName) {
    //   this.showErrorMsg('请填写巡检计划名称');
    //   return;
    // }
    // pamars.project_name = this.formCont.planName;
    if (!this.formCont.event && !this.formCont.event.id && this.formCont.event.length < 1) {
      this.showErrorMsg('请选择巡检事件');
      return;
    }
    let eventList:any = [];
    if (this.isLower === 1) {
      let ds = '';
      this.formCont.event.forEach((element:any) => {
        let ev:any = {};
        ev.id = element.id;
        ev.name = element.name;
        ev.check = element.child;
        ev.event_pid = this.formCont.topEvent.id;
        ev.event_pname = this.formCont.topEvent.name;
        eventList.push(ev);
        // ds = ds + element.name;
      });
      let ev:any = {};
      ev.id = this.formCont.topEvent.id;
      ev.name = this.formCont.topEvent.name;
      ev.check = this.formCont.topEvent.child;
      ev.event_pid = 0;
      ev.event_pname = '';
      eventList.push(ev);
      pamars.trouble_describle = this.formCont.topEvent.name;
    } else {
      if (this.formCont.event && this.formCont.event.id) {
        let ev:any = {};
        ev.id = this.formCont.event.id;
        ev.name = this.formCont.event.name;
        ev.check = this.formCont.event.child;
        ev.event_pid = 0;
        ev.event_pname = '';
        eventList.push(ev);
        pamars.trouble_describle = this.formCont.event.name;
      }
    }
    pamars.event_list = JSON.stringify(eventList);

    if (this.isMustDevice && (!this.formCont.device || this.formCont.device.length < 1)) {
      this.showErrorMsg('请选择设备');
      return;
    }
    pamars.device_list = JSON.stringify(this.formCont.device);
    if (this.formCont.device && this.formCont.device.length === 1) {
      pamars.device_id = this.formCont.device[0].id;
      pamars.device_name = this.formCont.device[0].name;
    }
    if (this.isShowCus && (!this.formCont.customer || !this.formCont.customer.id)) {
      this.showErrorMsg('请选择客户');
      return;
    }
    if (this.isShowCus) {
      let cusId = '';
      if (parseInt(this.formCont.customer.customer_type) === 1) {
        cusId = this.formCont.customer.customer_company_id;
      } else {
        cusId = 'p' + this.formCont.customer.customer_user_id;
      }
      pamars.customer_company_id = cusId;
      pamars.customer_name = this.formCont.customer.name;
    }
    // if (this.isHaveUserDept && this.isMustCusDept && !(this.formCont.userDept && this.formCont.userDept.dept_id) ) {
    //   this.showErrorMsg( '请选择报修部门');
    //   return;
    // }
    // if (this.formCont.userDept && this.formCont.userDept.dept_id) {
    //   if(this.isShowCusDept){
    //     pamars.customer_dept_name = this.formCont.userDept.name;
    //     pamars.customer_dept_id = this.formCont.userDept.dept_id;
    //   }
    // }
    if (this.isHaveUserDept && this.isMustCusDept &&  (!this.formCont.userDept || this.formCont.userDept.length < 1)) {
      this.showErrorMsg( '请选择报修部门');
      return;
    }

    // 费用
    let costList:any = [];
    if (this.formCont.costType && this.formCont.costType.id) {
      let cost:any = {};
      cost.price_id = this.formCont.costType.id;
      cost.price_name = this.formCont.costType.price_name;
      cost.price_num = this.formCont.costValue;
      costList.push(cost);
    }
    if (this.dynamicCost && this.dynamicCost.length > 0) {
      for (var cost of this.dynamicCost) {
        if (cost.type && cost.type.id) {
          let costs:any = {};
          costs.price_id = cost.type.id;
          costs.price_name = cost.type.price_name;
          costs.price_num = cost.value;
          costList.push(costs);
        }
      }
    }
    if (!(costList && costList.length > 0) && this.isMustPrice) {
      this.showErrorMsg('请添加费用');
      return;
    }
    if (costList && costList.length > 0) {
      var strCostList = JSON.stringify(costList);
      pamars['price_list'] = strCostList;
    }
    pamars.cus_dept_list = JSON.stringify(this.formCont.userDept);
    if (this.formCont.userDept && this.formCont.userDept.length === 1) {
      pamars.customer_dept_name = this.formCont.userDept[0].name;
      pamars.customer_dept_id = this.formCont.userDept[0].dept_id;
    }
    if (!this.formCont.name && this.isMustContentUser) {
      this.showErrorMsg('请输入联系人姓名');
      return;
    }
    if (this.formCont.name) {
      if (this.formCont.name.length < 2 && this.formCont.name.length > 10) {
        this.showErrorMsg('请输入2-10位联系人姓名');
        return;
      }
    }
    if (this.isShowContentUser) {
      pamars.name = this.formCont.name;
    }

    if (!(this.formCont.mobile && this.formCont.mobile.length > 0) && this.isMustContentUserMobile) {
      this.showErrorMsg('请输入手机号码');
      return;
    }
    if (this.formCont.mobile && this.formCont.mobile.length > 0) {
      if (!(this.formCont.mobile.charAt(0) === '1' && this.formCont.mobile.length === 11)) {
        this.showErrorMsg('请输入正确的手机号码');
        return;
      }
      if (this.isShowContentUserMobile) {
        pamars.mobile = this.formCont.mobile;
      }
    }
    if (!(this.formCont.telephone && this.formCont.telephone.length > 0) && this.isMustContentUserPhone) {
      this.showErrorMsg('请输入联系电话');
      return;
    }
    if (this.formCont.telephone && this.formCont.telephone.length > 0) {
      if (!(this.formCont.telephone.length >= 3 && this.formCont.telephone.length <= 18)) {
        this.showErrorMsg('请输入3-18位联系电话,支持输入"-"、" _"');
        return;
      }
      if (this.isShowContentUserPhone) {
        pamars.phone = this.formCont.telephone;
      }
    }
    if (!this.isMustContentUserPhone && !this.isMustContentUserMobile && this.isShowContentUserMobile && this.isShowContentUserPhone &&
    !(this.formCont.mobile && this.formCont.mobile.length > 0) && !(this.formCont.telephone && this.formCont.telephone.length > 0)) {
      this.showErrorMsg('请输入手机号码 或 3-18位联系电话,支持输入"-"、" _"');
      return;
    }

    if (this.isShowAddressPca) {
      if (!this.formCont.area && this.isMustAddressPca) {
        this.showErrorMsg('请选择省市区');
        return;
      }
      pamars.province = this.formCont.province;
      pamars.province_name = this.formCont.province_name;
      pamars.city = this.formCont.city;
      pamars.city_name = this.formCont.city_name;
      pamars.district_name = this.formCont.district_name;
      pamars.district = this.formCont.district;
    }
    if (this.isShowAddressSelf) {
      if (!this.formCont.area && this.isMustAddressSelf) {
        this.showErrorMsg('请选择所在地区');
        return;
      }
      pamars['one_address_id'] = this.oneAddressId;
      pamars['one_address_name'] = this.oneAddress;
      pamars['two_address_id'] = this.twoAddressId;
      pamars['two_address_name'] = this.twoAddress;
      pamars['three_address_id'] = this.threeAddressId;
      pamars['three_address_name'] = this.threeAddress;
    }
    if (!this.formCont.address && this.isMustAddress) {
      this.showErrorMsg('请输入地址');
      return;
    }
    if (this.isShowAddress) {
      if (this.formCont.address) {
        pamars.address = this.formCont.address;
      }
    }

    // 客服
    if (this.formCont.service && this.formCont.service.id) {
      pamars.servicer_user_id = this.formCont.service.id;
      pamars.servicer_user_name = this.formCont.service.name;
    }
    // 工程师或部门
    if (this.formCont.deptengineerObj.servicer_dept_id) {
      pamars.servicer_dept_id = this.formCont.deptengineerObj.servicer_dept_id;
      pamars.servicer_dept_name = this.formCont.deptengineerObj.servicer_dept_name;
    }
    if (this.formCont.deptengineerObj.engList && this.formCont.deptengineerObj.engList.length > 0) {
      let engList:any = [];
      this.formCont.deptengineerObj.engList.forEach((element:any) => {
        let eng:any = {};
        eng.user_id = element.user_id ? element.user_id : element.id;
        eng.user_name = element.user_name ? element.user_name : element.name;
        if (this.formCont.deptengineerObj.servicer_dept_id) {
          eng.dept_id = this.formCont.deptengineerObj.servicer_dept_id;
          eng.dept_name = this.formCont.deptengineerObj.servicer_dept_name;
        }
        engList.push(eng);
      });
      pamars.servicer_work_user = JSON.stringify(engList);
    }

    if (!this.formCont.startTime) {
      this.showErrorMsg('请选择开始时间');
      return;
    }
    if (!this.formCont.endTime) {
      this.showErrorMsg('请选择结束时间');
      return;
    }
    // if (new Date(this.formCont.endTime).getTime() - new Date(this.formCont.startTime).getTime() > 30 * 24 * 60 * 60 * 1000) {
    //   this.showErrorMsg('最多选择30天时间');
    //   return;
    // }
    if (new Date(this.formCont.endTime).getTime() < new Date(this.formCont.startTime).getTime() ) {
       this.showErrorMsg('结束时间需大于开始时间');
       return;
    }
    pamars.start_day = this.formCont.startTime;
    pamars.end_day = this.formCont.endTime;

    pamars.immediately = immediately;
    if (!this.formCont.repetition) {
      this.showErrorMsg('请选择执行频率');
      return;
    }
    pamars.repeat_type = this.formCont.repetition;
    if (!this.formCont.day) {
      this.showErrorMsg('选择提前生订单时间');
      return;
    }
    pamars.ahead_generate_day = this.formCont.day;

    let yearmonth = '';
    let monthday = '';
    let weekday = '';
    switch (parseInt(this.formCont.repetition)) {
      case 1:
        if (this.formCont.repetitionYearEveryMonth) {
          this.formCont.repetitionYearEveryMonth.forEach((element:any) => {
            yearmonth = yearmonth + element.value + ',';
          });
        }
        pamars.repeat_times = this.formCont.repeatTimes;
        pamars.year_month = yearmonth ? yearmonth.substring(0, yearmonth.length - 1) : '';
        pamars.year_week = this.formCont.repetitionYearWW;
        pamars.year_weekday = this.formCont.repetitionYearWhich;
        pamars.have_year_weekday = this.formCont.repetitionYearWeek ? '1' : '0';
        if( '' == pamars.year_month ) {
          this.showErrorMsg('选择月');
          return ;
        }
        if( '1' != pamars.have_year_weekday ) {
          this.showErrorMsg('选勾选星期');
          return ;
        }
         if( '' == pamars.year_week ) {
          this.showErrorMsg('选择星期');
          return ;
        }
        if( '' == pamars.year_weekday ) {
          this.showErrorMsg('选择星期详情信息');
          return ;
        }
        break;
      case 2:
        pamars.repeat_times = this.formCont.repeatTimes;
        if (this.formCont.repetitionMonthEveryday) {
          this.formCont.repetitionMonthEveryday.forEach((element:any) => {
            monthday = monthday + element.value + ',';
          });
        }
        pamars.repeat_times = this.formCont.repeatTimes;
        pamars.month_type = this.formCont.repetitionMonthType;
        if (this.formCont.repetitionMonthType === 'day') {
          pamars.month_day = monthday ? monthday.substring(0, monthday.length - 1) : '';
          if( '' == pamars.month_day ) {
            this.showErrorMsg('请选择天');
            return ;
          }
        } else {
          pamars.month_week = this.formCont.repetitionMonthWW;
          pamars.month_weekday = this.formCont.repetitionMonthWhich;
          if( '' == pamars.month_week ) {
            this.showErrorMsg('选择星期');
            return ;
          }
          if( '' == pamars.month_weekday ) {
            this.showErrorMsg('选择星期详情信息');
            return ;
          }
        }
        break;
      case 3:
        pamars.repeat_times = this.formCont.repeatTimes;
        this.formCont.checkboxWeek.forEach((element:any) => {
          weekday = weekday + element + ',';
        });
        pamars.week_weekday = weekday ? weekday.substring(0, weekday.length - 1) : '';
        if( '' == pamars.week_weekday ) {
            this.showErrorMsg('选择星期详情信息');
            return ;
        }
        break;
      case 4:
        pamars.repeat_times = this.formCont.repeatTimes;
        break;
      case 5:
        break;
    }
    let executionTime:any = [];
    // if (!(this.formCont.timelist &&
    // (this.formCont.timelist[0].hours && this.formCont.timelist[0].hours.value && this.formCont.timelist[0].minutes && this.formCont.timelist[0].minutes.value))) {
    //   this.showErrorMsg('请选择执行时间')
    //   return
    // }
    if (this.formCont.timelist) {
      this.formCont.timelist.forEach((element:any) => {
        let obj:any = {};
        obj.start_time_hours = element.hours.value;
        obj.start_time_minute = element.minutes.value;
        executionTime.push(obj);
      });
    }
    pamars.execution_time = JSON.stringify(executionTime);
    let ahead = 0;
    if (this.formCont.ahead) {
      if (parseInt(this.formCont.ahead) === 1) {
        ahead = 0;
      } else if (parseInt(this.formCont.ahead) === 2) {
        ahead = parseInt(this.formCont.ahead) * 30 * 60;
      } else {
        ahead = parseInt(this.formCont.ahead) * 60 * 60;
      }
      pamars.ahead_inform_time = ahead;
    }
    this.loading = true;
    addPlan(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.loading = false;
      this.jumpImportTask();
      setTimeout(() => {
        this.rest();
      }, 10)
    }).catch(err => {
      this.showErrorMsg(err.msg);
      this.loading = false;
    });
  }
  private rest() {
    // this.selectDevice = [];
    // this.formCont = {
    //   customer: '',
    //   area: '',
    //   address: '',
    //   topEvent: '',
    //   name: '',
    //   mobile: '',
    //   telephone: '',

    //   device: [],
    //   event: '',

    //   planName: '',
    //   service: '',
    //   deptengineer: '',
    //   deptengineerObj: {},

    //   startTime: '',
    //   endTime: '',
    //   day: '',
    //   repetition: '',
    //   repeatTimes: 1,
    //   checkboxWeek: [],
    //   repetitionMonthEveryday: [],
    //   repetitionMonthType: 'day',
    //   repetitionMonthWW: '',
    //   repetitionMonthWhich: '',
    //   repetitionYearWeek: '',
    //   repetitionYearWW: '',
    //   repetitionYearWhich: '',
    //   repetitionYearEveryMonth: [],

    //   timelist: [{
    //     hours: { value: 0,
    //       label: '00' },
    //     minutes: { value: 0,
    //       label: '00' }

    //   }],
    //   ahead: ''
    // };
    // this.repetitionMonthEveyday = []
    // this.init()
    // this.repetitionYearTable = [{
    //   row: [{
    //     value: 1,
    //     name: '一月'
    //   }, {
    //     value: 2,
    //     name: '二月'
    //   }, {
    //     value: 3,
    //     name: '三月'
    //   }, {
    //     value: 4,
    //     name: '四月'
    //   }]
    // }, {
    //   row: [{
    //     value: 5,
    //     name: '五月'
    //   }, {
    //     value: 6,
    //     name: '六月'
    //   }, {
    //     value: 7,
    //     name: '七月'
    //   }, {
    //     value: 8,
    //     name: '八月'
    //   }]
    // }, {
    //   row: [{
    //     value: 9,
    //     name: '九月'
    //   }, {
    //     value: 10,
    //     name: '十月'
    //   }, {
    //     value: 11,
    //     name: '十一月'
    //   }, {
    //     value: 12,
    //     name: '十二月'
    //   }]
    // }]
    // window.location.reload();
    this.$router.go(0)
  }
  private jumpImportTask() {
    let routeData = this.$router.resolve({
      path: '/ImportTask',
      query: {}
    });
    window.open(routeData.href);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
